import * as actions from "../action.constants";

const requestAddrresses = (data) => ({
  type: actions.REQUEST_ADDRESS_SAGA,
  pageUrl: data,
});

const requestAddAddrresses = (requestPayload, callback) => ({
  type: actions.REQUEST_ADD_ADDRESS_SAGA,
  requestPayload,
  callback,
});

const requestUpdateAddrress = (requestPayload, callback) => ({
  type: actions.REQUEST_UPDATE_ADDRESS_SAGA,
  requestPayload,
  callback,
});

const requestDeleteAddrress = (requestPayload, callback) => ({
  type: actions.REQUEST_DELETE_ADDRESS_SAGA,
  requestPayload,
  callback,
});

export {
  requestAddrresses,
  requestAddAddrresses,
  requestUpdateAddrress,
  requestDeleteAddrress,
};
